import { apiClient } from '@src/config/api';
import { ResponseSettings, SettingsKey } from '@src/shared/models';

export const SettingsApi = {
  getSettings: (settings: SettingsKey[]) =>
    apiClient.get<ResponseSettings>(
      `/setting/parameters?key=${settings.join(',')}`
    ),
} as const;
